import { render, staticRenderFns } from "./FormatTwoPaneSelector.vue?vue&type=template&id=7a43a7e8&scoped=true&"
import script from "./FormatTwoPaneSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatTwoPaneSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatTwoPaneSelector.vue?vue&type=style&index=0&id=7a43a7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a43a7e8",
  null
  
)

export default component.exports